export default "__VITE_ASSET__BG48OEjf__"